var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 2.80002H13.8001V0.850024C13.8001 0.601512 13.5986 0.400024 13.3501 0.400024H13.0501C12.8016 0.400024 12.6001 0.601512 12.6001 0.850024V2.80002H5.4001V0.850024C5.4001 0.601512 5.19861 0.400024 4.9501 0.400024H4.6501C4.40159 0.400024 4.2001 0.601512 4.2001 0.850024V2.80002H2.4001C1.40597 2.80002 0.600098 3.6059 0.600098 4.60002V17.8C0.600098 18.7941 1.40597 19.6 2.4001 19.6H15.6001C16.5942 19.6 17.4001 18.7941 17.4001 17.8V4.60002C17.4001 3.6059 16.5942 2.80002 15.6001 2.80002ZM2.4001 4.00002H15.6001C15.9309 4.00002 16.2001 4.2692 16.2001 4.60002V6.40002H1.8001V4.60002C1.8001 4.2692 2.06927 4.00002 2.4001 4.00002ZM15.6001 18.4H2.4001C2.06927 18.4 1.8001 18.1308 1.8001 17.8V7.60002H16.2001V17.8C16.2001 18.1308 15.9309 18.4 15.6001 18.4Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.b79cf70654d5072def32727ae6b15901.svg";
export { ForwardRef as ReactComponent };